export type DocumentEditOwner =
  | { clientId: string; familyId?: never }
  | { familyId: string; clientId?: never };

export function resolveDocumentEditOwner(
  clientId?: string | null,
  familyId?: string | null,
): DocumentEditOwner | null {
  if (clientId && !familyId) return { clientId };
  if (familyId && !clientId) return { familyId };
  return null;
}
